import { type ReactNode } from 'react';
import classnames from 'classnames';

interface TagProps {
  children?: ReactNode;
  variant?: 'bold' | 'default';
  size?: 'sm' | 'default';
  testId?: string;
}

const Tag = ({ children, variant = 'default', size = 'default', testId }: TagProps) => (
  <div
    className={classnames(
      'd-flex align-items-center border border-light-button-bg rounded bg-light-button-bg text-light-button-text',
      {
        'fw-bold': variant === 'bold',
      },
      {
        'py-0_5 px-2': size === 'sm',
        'py-1_5 px-2_5': size === 'default',
      }
    )}
    data-testid={testId}
  >
    <span>{children}</span>
  </div>
);

export default Tag;
